import { ReimbursementStatus } from '@/features/reimbursements/types/reimbursement'

const statusMap: Map<string, ReimbursementStatus> = new Map([
  ['pending', 'PENDING'],
  ['pay', 'APPROVED'],
])
/**
 * Modifies the query parameters based on the pathname.
 * If the pathname includes a segment that matches a key in the statusMap,
 * the function will add or replace the 'status' query parameter with the corresponding value.
 * If there's no match in the pathname, the original query parameters are returned unchanged.
 *
 * @param queryparams - The original query parameters as a string
 * @param pathname - The current pathname
 * @returns The modified query parameters as a string
 */
export const getQueryByTab: (
  queryparams: string,
  pathname: string,
) => string = (queryparams, pathname) => {
  const params = new URLSearchParams(queryparams)
  for (const [pathSegment, status] of statusMap) {
    if (pathname.includes(pathSegment)) {
      // Remove existing status parameter if present
      params.delete('status')
      // Remove myReimbursements parameter if present as it is only needed in overview view
      params.delete('myReimbursements')
      // Add new status parameter
      params.set('status', status)
      break
    }
  }

  return params.toString()
}

export const getActiveTab = (pathname: string) => {
  return [pathname.includes('/pending'), pathname.includes('/pay')]
}
